import React, { useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Redirect, Route, useLocation } from 'react-router-dom';
import { AppDispatch, RootState } from '../../logic/store/Store';
import { validateToken, clearState } from '../../logic/store/User/AuthSlice';
import { makeDispatch } from '../../logic/Utility/Utils';
import { POST_LOGIN_REDIRECT_KEY } from './authRedirect';

interface ILoggedInProps
{
	exact?: boolean;
	path: string | string[];
	children?: JSX.Element;
}


const LoggedInRouteWithRedirectComponent = (props: ILoggedInProps & PropsFromRedux) =>
{
	const { isAuthenticated, children, exact, path, ClearAuthentication } = props;
	const location = useLocation();

	if(!isAuthenticated)
	{
		// If we are not logged in, record the intended url and redirect to okta for authentication
		const intendedUrl = `${location.pathname}${location.search}${location.hash}`;
		localStorage.setItem(POST_LOGIN_REDIRECT_KEY, intendedUrl);

		ClearAuthentication();

		// Send them to login (which should route them into Okta flow)
		return <Redirect to="/login" />;
	}

	return (
		<Route
			path={path}
			exact={exact}
			render={() => children}
		/>
	);
};

const mapStateToProps = (state: RootState) => ({
	userAuthToken: state.auth.userAuthToken,
	isAuthenticated: state.auth.isAuthenticated,
	isLoadingAuth: state.auth.isLoading,
});

const mapDispatchToProps = (dispatch: AppDispatch) =>
{
	return {
		ClearAuthentication: makeDispatch(dispatch, clearState),
		performTokenValidation: (token: string) => dispatch(validateToken(token))
	};
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export const LoggedInRouteWithRedirect = connector(LoggedInRouteWithRedirectComponent);